	//console.log("Search!");

	document.addEventListener('DOMContentLoaded', function() {
  	const searchForm = document.getElementById('search-formo');
		const searchInput = searchForm.querySelector('input[type="search"]');

  	const searchResults = document.getElementById('search-results');
  	const showMoreLink = document.getElementById('show-more');
  	const showingTopResults = document.getElementById('showing-top-results');

  	function formatPrice(price) {
  		return new Intl.NumberFormat('en-US', {
  			style: 'currency',
  			currency: 'USD'
  		}).format(price / 100);
  	}

  	searchInput.addEventListener('input', function() {
  		const query = searchInput.value;

			console.log(query);

		if (query.length > 2) {
			searchResults.setAttribute('aria-busy', 'true');
			fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[options][unavailable_products]=hide`)
  				.then(response => response.json())
  				.then(data => {
  					const products = data.resources.results.products;
  					let resultsHTML = '';

  					if (products.length > 0) {
  						products.forEach(product => {

								//console.log(product);
  							let formattedPrice = Shopify.formatMoney(product.price);
  							formattedPrice = formattedPrice.replace(/(\.\d{2})$/, '');

  							let formattedCompareAtPrice = null;
  							if (product.compare_at_price && product.compare_at_price > product.price) {
  								formattedCompareAtPrice = Shopify.formatMoney(product.compare_at_price);
  								formattedCompareAtPrice = formattedCompareAtPrice.replace(/(\.\d{2})$/, '');
  							}

  							resultsHTML += `
                  <div class="product">
										<a href="${product.url}" class="img-link">
                      <img class="single" src="${product.featured_image.url}" alt="${product.title}" />
										</a>

                    <div class="details">
                      <div class="top">
                        <a href="${product.url}" class="title">
                          ${product.title.split(' - ')[0]}
                        </a>

                        <a href="${product.url}" class="price">
                          ${formattedPrice}
                        </a>
                      </div><!-- Top -->

                      <div class="bottom">
                        <div class="lefto">
                          <!-- Include additional product details like sizes and colors here if available -->
                        </div>

                        ${product.compare_at_price > product.price ? `
                          <div class="righto">
                            <span class="sale-price">
                              ${formattedPrice}
                            </span>
                          </div>` : ''
                        } 
                      </div><!-- Bottom -->

                    </div><!-- Details -->
                  </div><!-- Product -->
                `;
  						});

  						// Show the "Showing Top Results" message and "View All Search Results" link
  						showingTopResults.classList.remove('hide');
  						showMoreLink.classList.remove('hide');

  						showMoreLink.href = `/search?q=${encodeURIComponent(query)}`;

  					} else {
  						resultsHTML = '<span class="product ag">No Results Found</span>';
  						showingTopResults.classList.add('hide');
  						showMoreLink.classList.add('hide');
  					}

					searchResults.innerHTML = resultsHTML;
					searchResults.setAttribute('aria-busy', 'false');
				})
				.catch(error => {
					console.error('Error fetching search results:', error);
					searchResults.setAttribute('aria-busy', 'false');
					searchResults.innerHTML = '<span class="product ag">Search results are temporarily unavailable.</span>';
				});
		} else {
			searchResults.innerHTML = '';
			searchResults.setAttribute('aria-busy', 'false');
				showingTopResults.classList.add('hide');
				showMoreLink.classList.remove('hide');
  		}
			
  	});
  });
